import { BuildingOffice2Icon } from "@/icons/solid";
import LoadingContent from "@/components/common/LoadingContent";

export default function SwitchingCompany() {
	return (
		<div
			style={{
				position: "absolute",
				left: "50%",
				top: "50%",
				WebkitTransform: "translate(-50%, -50%)",
				transform: "translate(-50%, -50%)",
				textAlign: "center",
			}}
		>
			<BuildingOffice2Icon style={{ height: "25%", width: "25%", color: "rgb(234,97,28)" }} />
			<h1 style={{ paddingBottom: "50vh", textAlign: "center" }}>Switching Your Company...</h1>
			<LoadingContent style={{ height: "20%", width: "20%" }} />
		</div>
	);
}